import ServiceJobCategoryModel from "./ServiceJobCategoryModel";
import ServiceJobComponentModel from "./ServiceJobComponentModel";
import ServiceJobGroupModel from "./ServiceJobGroupModel";
import ServiceJobOperationModel from "./ServiceJobOperationModel";

export default class ServiceJobModel {
	constructor(data?: any) {
		if (data) {
			this.id = data.id ?? 0;
						
			if (data.category?.id) {
				this.category = new ServiceJobCategoryModel(data.category);
			}

			if (data.component?.id) {
				this.component = new ServiceJobComponentModel(data.component);
			}
			
			if (data.operation?.id) {
				this.operation = new ServiceJobOperationModel(data.operation);
			}

			if (data.group?.id) {
				this.group = new ServiceJobGroupModel(data.group);
			}

			if (data.estimationHrs) {
				this.estimationHrs = data.estimationHrs;
			}
		}
	}

	id = 0;
	category!: ServiceJobCategoryModel;
	component!: ServiceJobComponentModel;
	operation!: ServiceJobOperationModel;
	group: ServiceJobGroupModel | null = null;
	estimationHrs: number | null = null;
}